module.exports = __webpack_public_path__ + "c915c1548424c6a5a2e3abd9945478da.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Detail/mark.png
// module id = 1920
// module chunks = 0